import React, { useEffect, useState } from "react";
import {
    Box,
    FormControl,
    Checkbox,
    Typography,
} from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMultipleSelectChecklist({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [checkedItems, setCheckedItems] = useState([]);
    const [questionList, setQuestionList] = useState(
        makeArrayRandom(questionData.questionList)
    );

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setCheckedItems([]);
        setQuestionList(makeArrayRandom(questionData.questionList));
    }, [question,
        questionData.questionList,
    ]);

    const handleCheck = (item) => {
        const newCheckedItems = checkedItems.includes(item)
            ? checkedItems.filter((i) => i !== item)
            : [...checkedItems, item];

        setCheckedItems(newCheckedItems);

        const canProceed = newCheckedItems.length > 0;
        onAnswer({
            canProceed,
            answer: newCheckedItems,
        });
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                padding: 2,
                gap: 4,
            }}
        >
            <Box
                component="img"
                src={`${imagesResources}${data.image}`}
                alt="Question Image"
                sx={{
                    objectFit: "contain",
                }}
            />

            <Box
                sx={{
                    backgroundColor: "rgb(232, 240, 254)",
                    width: "250px",
                }}
            >
                <Box
                    sx={{
                        backgroundColor: "rgb(21, 101, 192)",
                        color: "white",
                        padding: "8px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "22px",
                    }}
                >
                    {data.questionHeader}
                </Box>

                <FormControl component="fieldset" sx={{ padding: "8px" }}>
                    {questionList.map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                marginBottom: "8px",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: "bold",
                                    textAlign: "right",
                                    marginRight: "8px",
                                    fontSize: "18px",
                                }}
                            >
                                {item}
                            </Typography>
                            <Checkbox
                                checked={checkedItems.includes(item)}
                                onChange={() => handleCheck(item)}
                                sx={{
                                    "& .MuiSvgIcon-root": {
                                        fill: "rgb(21, 101, 192)",
                                        borderRadius: 0,
                                    },
                                }}
                            />
                        </Box>
                    ))}
                </FormControl>
            </Box>
        </Box>
    );
};
